import type { TableProps } from 'antd'
import type { ListTableProps } from 'src/components/base/ListTable'
import type { FilterGroup } from 'src/utils/common'
import React, { useEffect } from 'react'
import { ListPageHeader, ListPageTable } from './components'
import { searchStore, listStore } from 'src/stores'
import 'src/styles/components/root/listPage.less'

type FormData = {
  // FORM_TYPE_EDITLIST_PAGE 可编辑列表表单
  __EDIT_V1__?: boolean,
  // FORM_TYPE_DYNAMIC_EDITLIST_PAGE 动态列可编辑列表表单
  __EDIT_V2__?: boolean,
  // 查询参数
  filterGroup?: FilterGroup,
  // antd Table 配置
  tableProps?: TableProps<any>,
  // ListTable 相关配置
  listTable?: Omit<ListTableProps, 'formCode'>,
}

type Props = {
  formCode: string,
  formData?: FormData,
}

const ListPropsContext = React.createContext<Props>({ formCode: '' })
const ListPage = (props: Props) => {
  useEffect(() => {
    return () => {
      const { formCode } = props
      searchStore.search.delete(formCode)
      listStore.table.delete(formCode)
    }
  }, [])

  return (
    <ListPropsContext.Provider value={props}>
      <div className='list-page'>
        <ListPageHeader />
        <ListPageTable />
      </div>
    </ListPropsContext.Provider>
  )
}

export { ListPropsContext }
export default ListPage